import Vue from 'vue';

const success = (response, context) => {
  context.rental.booking_email = response.data.email;
  context.rental.forward_email = response.data.forward_email;
  context.openModal("#rental-email-modal");
};

const failed = (error, context) => {
  toastr.error("Rental not found");
};

export default (context, rental_id) => {
  return Vue.$http.get('rental/generate-email/'+rental_id).then(response => {
    if(response && response.status === 200) {
      success(response, context);
    }
  }).catch(error => {
    failed(error, context);
  });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/generateEmail.js